<template>
	<div>
		<div class="flex flex_justify_end">
			<a @click="selectFiveHundred" class="button is-info is-outlined">500</a>
			<div class="horizontal_space"></div>
			<a @click="form.data.expense.fields.name.value = 'ACC'" class="button is-info is-outlined">ACC</a>
			<div class="horizontal_space"></div>
			<a @click="form.data.expense.fields.name.value = 'מועמד'" class="button is-info is-outlined">מועמד</a>
			<div class="horizontal_space"></div>
			<a @click="form.data.expense.fields.name.value = 'חבר מביא חבר'" class="button is-info is-outlined">חבר מביא חבר</a>
		</div>
		<div v-if="form">
			<div>
				<p class="bold">Name</p>
				<input type="text" v-model="form.data.expense.fields.name.value" class="full_width">
			</div>
			<div>
				<p class="bold">Amount</p>
				<input type="text" v-model="form.data.expense.fields.amount.value">
			</div>
		</div>
		<div class="modal_footer">
			<a
				@click="submit()"
				:class="{ 'is-loading': is_loading }"
				class="button is-info"
				>Submit</a
			>
		</div>
	</div>
</template>
<script>
	import { mapMutations, mapActions } from 'vuex'
	export default {
		name: 'expense-form',
		props: ['payload'],
		data(){
			return {
				is_loading: false,
				form: undefined,
			}
		},
		created(){
			if(this.payload.is_create){
				this.setForm({
					id: '',
				})
				return
			}
			this.$network_utils.getExpense(this.payload.data.id).then(response => {
				this.setForm(response)
			})
		},
		methods: {
		    setForm (form_data) {
		      this.form = new this.$form({
		        expense: {
		          fields: {
		            name: {
		              value: form_data.name,
		              has_error: false,
		              validations: ['Exists']
		            },
		            amount: {
		              value: form_data.amount,
		              has_error: false,
		              validations: ['Number', 'Exists']
		            },
		            offer_id: {
		              value: this.payload.offer.id,
		              has_error: false,
		              validations: ['Exists']
		            },
		          },
		          request_details: {
		            method: this.payload.is_create ? 'post' : 'put',
		            url: '/expenses/' + form_data.id,
		          },
		          is_used: true
		        }
		      })
		    },
		    submit () {
				let response = this.form.mySubmit()
				if (response === false) {
					return
				}
				this.is_loading = true
				response.promise.then((response) => {
					if(this.payload.callback != undefined){
						this.payload.callback()
					}
					this.is_loading = false
					this.removeModal(this.payload)
				}).catch(() => {
					this.showToast('ארעה שגיאה')
				})
		    },
		    selectFiveHundred(){
		    	this.form.data.expense.fields.name.value = '500'
		    	this.form.data.expense.fields.amount.value = '500'
		    },
				...mapActions('toasts', ['showToast']),
		    ...mapMutations('modals', ['removeModal'])
		}
	}
</script>